module.exports = __webpack_public_path__ + "img/logo310x310.78e53524.png";